import { getProperty as getObjectProperty } from 'customer-data-objects/objects/ObjectAccessors';
// TODO: Remove this implementation after getObjectProperty supports null
export const getProperty = (...args) => getObjectProperty(...args);